import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

function PresentaEncuestas() {
  const { idTipo, idEncuesta, idSolicitud } = useParams();
  const [respuestas, setRespuestas] = useState({
    abierta: "",
    seleccion: "",
    calificacion: "",
    comentarios: "",
    criterio: "",
  });
  const [list, setList] = useState([]);
  const [answeredList, setAnsweredList] = useState([]); // Guarda las respuestas
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `https://suadesarrollo.azurewebsites.net/api/ObtenerPreguntasPorTipo/${idTipo}/${idEncuesta}`,
          {
            auth: {
              username: "BasicAuth@icontec.org",
              password: "yQLzqmR7eZSuAmQZUqhY",
            },
          },
        );
        setList(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [idTipo, idEncuesta]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRespuestas({ ...respuestas, [name]: value });
  };

  const postData = async (e) => {
    e.preventDefault();

    const preguntasAbiertas = list.filter(
      (item) => item.tipoRespuesta === "Abierta",
    );

    // Validar preguntas abiertas
    for (const pregunta of preguntasAbiertas) {
      if (!respuestas.abierta || !respuestas.criterio) {
        Swal.fire({
          icon: "warning",
          title: "Campos incompletos",
          text: "Debe completar todas las opciones de la pregunta abierta",
        });
        return;
      }
    }

    const result = await Swal.fire({
      title: "¿Está seguro?",
      text: "¿Desea guardar la respuesta que seleccionó?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, guardar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    });

    // Si cancela no hace nada
    if (!result.isConfirmed) return;

    const calificacionValue = respuestas.calificacion || "0";
    setIsLoading(true);

    try {
      const response = await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/CreaRespuestaEncuestas",
        {
          abierta: respuestas.abierta,
          seleccion: respuestas.seleccion,
          calificacion: calificacionValue,
          preguntaId: list.map((item) => item.id).join(""),
          encuestaid: idEncuesta,
          comentarios: respuestas.comentarios,
          criterioAuditor: respuestas.criterio,
          solicitudId: idSolicitud,
        },
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );

      // Guardar en lista local
      setAnsweredList([...answeredList, respuestas]);

      // Limpiar formulario
      setRespuestas({
        abierta: "",
        seleccion: "",
        calificacion: "",
        comentarios: "",
        criterio: "",
      });

      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "La respuesta fue guardada correctamente",
        timer: 2000,
        showConfirmButton: false,
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Error posting data:", error);

      if (error.response) {
        if (error.response.status === 400) {
          Swal.fire({
            icon: "warning",
            title: "Respuesta ya registrada",
            text: "Esta pregunta ya fue diligenciada anteriormente.",
          });
        } else if (error.response.status === 401) {
          Swal.fire({
            icon: "error",
            title: "No autorizado",
            text: "No tiene permisos para realizar esta acción.",
          });
        } else if (error.response.status === 500) {
          Swal.fire({
            icon: "error",
            title: "Error del servidor",
            text: "Ocurrió un error interno al guardar la respuesta.",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Ocurrió un error al guardar la respuesta.",
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Error de conexión",
          text: "No fue posible conectar con el servidor.",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const finalizarEncuesta = () => {
    window.location.href = "/#/EncuestaPorTipo/" + idTipo + "/" + idSolicitud;
  };

  return (
    <div className="text-center">
      <div className="card shadow mb-4">
        <div className="card-body">
          <h4 className="m-0 font-weight-bold text-primary ">Encuesta</h4>
          <hr />
          <div className="table-responsive">
            {isLoading ? (
              <p>Cargando...</p>
            ) : list.length === 0 ||
              list.every((item) => !item.tipoRespuesta) ? (
              <div>
                <h5>Resumen de las Respuestas</h5>
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Pregunta Id</th>
                      <th>Rta Abierta</th>
                      <th>Rta Selección Si/No</th>
                      <th>Rta Calificación (1-5)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((respuesta, index) => (
                      <tr key={index}>
                        <td>{respuesta.preguntaId}</td>
                        <td>{respuesta.abierta}</td>
                        <td>{respuesta.seleccion}</td>
                        <td>{respuesta.calificacion}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <button
                  className="btn btn-primary btn-user btn-block"
                  onClick={finalizarEncuesta}
                >
                  Finalizar
                </button>
              </div>
            ) : (
              <form onSubmit={postData}>
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Pregunta</th>
                      <th>Diligencia su Respuesta</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map(
                      (item, index) =>
                        item.tipoRespuesta && (
                          <tr key={index}>
                            <td>{item.pregunta}</td>
                            {item.tipoRespuesta === "Abierta" && (
                              <td>
                                <textarea
                                  name="abierta"
                                  className="form-control"
                                  placeholder="Respuesta"
                                  onChange={handleInputChange}
                                  value={respuestas.abierta}
                                />
                                <hr />
                                <select
                                  name="criterio"
                                  className="form-control"
                                  onChange={handleInputChange}
                                  value={respuestas.criterio}
                                >
                                  <option value="">
                                    Seleccione su respuesta
                                  </option>
                                  <option value="C">Correcto</option>
                                  <option value="P">Parcial</option>
                                  <option value="I">Incorrecto</option>
                                </select>
                              </td>
                            )}
                            {item.tipoRespuesta === "Seleccion" && (
                              <td>
                                <select
                                  name="seleccion"
                                  className="form-control"
                                  onChange={handleInputChange}
                                  value={respuestas.seleccion}
                                  required
                                >
                                  <option value="">
                                    Seleccione su respuesta
                                  </option>
                                  <option value="Si">Si</option>
                                  <option value="No">No</option>
                                  <option value="Na">Na</option>
                                </select>
                              </td>
                            )}
                            {item.tipoRespuesta === "Calificacion" && (
                              <td>
                                <select
                                  name="calificacion"
                                  className="form-control"
                                  onChange={handleInputChange}
                                  value={respuestas.calificacion}
                                  required
                                >
                                  <option value="">
                                    Seleccione la calificación
                                  </option>
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">Na</option>
                                </select>
                              </td>
                            )}
                            {item.tipoRespuesta === "Paciente" && (
                              <td>
                                <select
                                  name="calificacion"
                                  className="form-control"
                                  onChange={handleInputChange}
                                  value={respuestas.calificacion}
                                  required
                                >
                                  <option value="">
                                    Seleccione la calificación
                                  </option>
                                  <option value="1">1</option>

                                  <option value="3">3</option>

                                  <option value="5">5</option>

                                  <option value="7">Na</option>
                                </select>
                              </td>
                            )}
                          </tr>
                        ),
                    )}
                    {respuestas.calificacion &&
                      respuestas.calificacion != "5" &&
                      respuestas.calificacion != "6" && (
                        <tr>
                          <td>Comentarios</td>
                          <td>
                            <textarea
                              required
                              name="comentarios"
                              className="form-control"
                              placeholder="Ingrese sus comentarios"
                              onChange={handleInputChange}
                              value={respuestas.comentarios}
                            />
                          </td>
                        </tr>
                      )}
                  </tbody>
                </table>
                <button
                  type="submit"
                  className="btn btn-primary btn-user btn-block"
                >
                  Guardar
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PresentaEncuestas;
